export const PREMIUM_CALCULATE = "PREMIUM_CALCULATE";
export const PREMIUM_CALCULATE_SUCCESS = "PREMIUM_CALCULATE_SUCCESS";
export const PREMIUM_CALCULATE_ERROR = "PREMIUM_CALCULATE_ERROR";
export const PREMIUM_CALCULATE_CLEAR_DATA = "PREMIUM_CALCULATE_CLEAR_DATA";
